import global from '@/common/global';
import util from '@/common/util';
/**
 * scroll&overlap affect transparent and hide
 */
const scrollMethods = {
    data: function() {
        return {
            useHide: false,
            hide: false,
            realTransparent: false
        };
    },
    methods: {
        init() {
            global.scroll(this.pageScroll, true);
            if (this.isOverlap) {
                global.scroll(this.pageScroll);
            } else {
                this.hide = false;
            }
            if (this.sticky) {
                util.topFixedHeight = this.$refs?.nav.offsetHeight ?? 0; 
            } else {
                util.topFixedHeight = 0; 
            }
        },
        pageScroll(scrollY) {
            if (this.beforePageScroll(scrollY)) {
                return;
            }
            if (scrollY > 0) {
                if (this.realTransparent) {
                    this.realTransparent = false;
                    this.sizeChange();
                }
            } else if (!this.realTransparent) {
                this.realTransparent = true;
                this.sizeChange();
            }
            this.useHide && this.scrollHide(scrollY);
            this.scrollY = scrollY;
        },
        scrollHide(scrollY) {
            if (!isNaN(this.scrollY) && !this.sticky) {
                if (scrollY < this.scrollY || scrollY <= 0) {
                    this.hide = false;
                } else {
                    this.hide = true;
                }
            }
        },
        beforePageScroll() {
            //return flag to stop
            return false;
        }
    }
};

const scrollLife = {
    created() {
        this.realTransparent = this.isOverlap;
    },
    mounted() {
        this.init();
    },
    unmounted() {
        this.isOverlap && global.scroll(this.pageScroll, true);
    }
};

const scrollWatch = {
    watch: {
        isOverlap() {
            this.realTransparent = this.isOverlap;
            this.init();
        },
        sticky() {
            this.init();
        }
    }
};

export default {
    ...scrollLife,
    ...scrollMethods,
    ...scrollWatch
};
export { scrollLife, scrollMethods, scrollWatch };
